import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4" }
const _hoisted_2 = { class: "flex gap-4 flex-col items-start md:flex-row md:justify-between md:items-center" }
const _hoisted_3 = { class: "text-4xl" }
const _hoisted_4 = { class: "flex flex-col gap-4" }
const _hoisted_5 = { class: "font-semibold flex items-center gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-arrow-down"
}
const _hoisted_7 = { class: "flex flex-wrap items-center justify-center gap-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import CButton from "@/components/Button.vue";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import SpaceForm from "./SpaceForm.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import PConfirmDialog from "primevue/confirmdialog";
import { useConfirm } from "primevue/useconfirm";
import { useNotify } from "@/composables/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const confirm = useConfirm();
const { t } = useI18n();
const toast = useToast();
const { successToast, errorToast } = useNotify({ t });
const store = useStore();
const activeSpace = ref<number>(-1);
const isShowCreateNew = ref(false);
const toggleCreateNew = (show: boolean) => {
  isShowCreateNew.value = show;
  if (isShowCreateNew.value) {
    closeAll();
  }
};
const canShowEditButtonsOnSpaces = computed(() => {
  return activeSpace.value < 0 && !isShowCreateNew.value;
});
const retrievePos = async () => {
  await store.dispatch("pos/RETRIEVE");
};

const selectSpace = (index: number) => {
  activeSpace.value = index;
};
const closeAll = () => {
  activeSpace.value = -1;
};

const updateASpace = async (space: any) => {
  try {
    await store.dispatch("space/UPDATE_SPACE", space);
    closeAll();
    successToast({ title: t("space"), detail: t("updatedSuccessfully") });

    await retrievePos();
  } catch (e: any) {
    errorToast({ title: t("space"), error: e.message });
  }
};
const createASpace = async (space: any) => {
  try {
    await store.dispatch("space/CREATE_SPACE", space);
    toggleCreateNew(false);
    successToast({ title: t("space"), detail: t("createdSuccessfully") });
    await retrievePos();
  } catch (e: any) {
    errorToast({ title: t("space"), error: e.message });
  }
};
const deleteSpace = (space: any) => {
  confirm.require({
    message: `${t("deletingTable")} ${space.name ?? ""} `,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: async () => {
      try {
        await store.dispatch("space/DELETE_SPACE", space);
        toggleCreateNew(false);
        successToast({ title: t("space"), detail: t("deletedSuccessfully") });
        await retrievePos();
      } catch (e: any) {
        errorToast({ title: t("space"), error: e.message });
      }
    },
  });
};
const spaces = computed(() => store.getters["pos/spaces"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_unref(PConfirmDialog)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("spaces")), 1),
        _createVNode(CButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCreateNew(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("addARoom")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, { name: "toggleable-content" }, {
          default: _withCtx(() => [
            (isShowCreateNew.value)
              ? (_openBlock(), _createBlock(SpaceForm, {
                  key: 0,
                  class: "p-5 border rounded shadow",
                  onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleCreateNew(false))),
                  onSave: createASpace
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(Accordion), {
          activeIndex: activeSpace.value,
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"]))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spaces), (space, spaceIndex) => {
              return (_openBlock(), _createBlock(_unref(AccordionTab), {
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"])),
                key: spaceIndex
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                    class: "flex flex-col md:flex-row justify-between items-center w-full gap-y-2 p-5"
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(space.name), 1),
                      (spaceIndex === activeSpace.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass([{ invisible: !_unref(canShowEditButtonsOnSpaces) }, "pi pi-pencil hover:cursor-pointer"]),
                        onClick: ($event: any) => (selectSpace(spaceIndex))
                      }, null, 10, _hoisted_8),
                      _createElementVNode("i", {
                        class: "pi pi-trash hover:cursor-pointer",
                        onClick: ($event: any) => (deleteSpace(space))
                      }, null, 8, _hoisted_9)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(SpaceForm, {
                    "is-update": "",
                    space: space,
                    onCancel: _cache[3] || (_cache[3] = ($event: any) => (closeAll())),
                    onSave: updateASpace
                  }, null, 8, ["space"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ])
    ])
  ]))
}
}

})